module.exports = __webpack_public_path__ + "img/3d-model_enBU.f0e96e3.jpg";